<div class="accordion horizontal">
  <ng-container *ngFor="let user of items; let i = index">
    <section
      id="{{ user.id }}"
      [lazyLoad]="user.cover_image"
      style="background-position: 50% 50%; background-size: cover"
      [defaultImage]="'assets/images/placeholder.png'"
      [errorImage]="'assets/images/placeholder.png'"
      [ngClass]="{ opened: openedTabId === user.id }"
      (click)="handleSectionClick(user)"
      class="member_{{ i }}"
    >
      <h2>
        <img
          *ngIf="!user.image_id || user.image_id === '0'"
          src="assets/images/avatar.svg"
          alt="{{ user.displayed_name ? user.displayed_name : user.company_name ? user.company_name : 'User Avatar' }}"
          class="avatar"
        />
        <img
          *ngIf="user.image_id && user.image_id !== '0'"
          [src]="user.image_id"
          class="avatar"
          alt="{{ user.displayed_name ? user.displayed_name : user.company_name ? user.company_name : 'User Avatar' }}"
        />
        <a routerLink="/community/members/{{ user.username }}" class="link-member">
          {{ user.displayed_name ?? user.company_name ?? user.username }}
        </a>
        <button class="btn-link-reset">{{ user.displayed_name ?? user.company_name ?? user.username }}</button>
      </h2>
      <div class="box-member">
        <p class="country">{{ user.country }}</p>
        <p class="username">
          <a routerLink="/community/members/{{ user.username }}">
            {{ user.displayed_name ?? user.company_name ?? user.username }}
          </a>
        </p>
        <p class="description">{{ user.member_description }}</p>
        <div class="items">
          Items for sale
          <div class="count">{{ user.listedItems }}</div>
        </div>
        <div class="items">
          Items sold
          <div class="count">{{ user.totalItemsSold }}</div>
        </div>
      </div>
    </section>
  </ng-container>
</div>
